import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import styles from './landingPage.module.css';
import { useTranslation } from 'react-i18next';
import copigoLogo from '../../assets/copigo-logo.png';

export const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <Box className={styles.container}>
      <Container maxWidth="lg" className={styles.contentContainer}>
        <Box className={styles.heroSection}>
          <Box className={styles.logoContainer}>
            <img src={copigoLogo} alt="Copigo Logo" className={styles.logo} />
          </Box>

          <Typography variant="h5" className={styles.subtitle}>
            {t('Your comprehensive office equipment rental management solution')}
          </Typography>

          <Box className={styles.featuresBox}>
            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Rental Tracking')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Track equipment rentals, availability, and returns in real-time')}
              </Typography>
            </Box>

            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Contract Management')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Manage rental agreements, clients, and billing effortlessly')}
              </Typography>
            </Box>

            <Box className={styles.feature}>
              <Typography variant="h6" className={styles.featureTitle}>
                {t('Inventory Management')}
              </Typography>
              <Typography variant="body1" className={styles.featureText}>
                {t('Monitor equipment status, maintenance schedules, and availability')}
              </Typography>
            </Box>
          </Box>

          <Box className={styles.actionsBox}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleLoginClick}
              className={styles.actionButton}
            >
              {t('Log in')}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={handleRegisterClick}
              className={styles.actionButton}
            >
              {t('Register')}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
